import { render, staticRenderFns } from "./baseSelectTable.vue?vue&type=template&id=b3fd627a&scoped=true"
import script from "./baseSelectTable.vue?vue&type=script&lang=js"
export * from "./baseSelectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd627a",
  null
  
)

export default component.exports